import superagent from 'superagent';
import uuidv4 from 'uuid/v4';
import * as types from './types';
import {userLogout,forbiddenAccess} from  './auth';

const request = superagent.agent().set('ETag', window.Config.APP_VERSION)
    .use(function(req) {
        req.on('response', function (res) {
            if (res.status === 401) {
            console.log('UnAuthorized');
              userLogout();
                
            }else if(res.status === 403){
              console.log('Forbidden');
              forbiddenAccess();
            }
        });
});


export function addStaffStart() {
    return {
      type: types.ADD_STAFF_START,
    };
  }
  
  export function addStaffSuccess() {
    return {
      type: types.ADD_STAFF_SUCCESS,
    };
  }
  
  export function addStaffFail(ex) {
    return {
      type: types.ADD_STAFF_FAIL,
      error: ex.message,
    };
  }
  
  export function addStaffMember(payload) {
    return (dispatch, getState) => {
      const { business, auth } = getState();
        const data = {
            firstName:payload.firstname, 
            lastName:payload.lastname, 
            email:payload.email, 
            phone:payload.phone,
            domain_id: auth.domain,
            business_id : business.id,
            role:payload.role,
            ...(payload.metadata && {metadata: payload.metadata})
        }
        dispatch(addStaffStart());
        return request.post(`${window.Config.API_URL}/client`).withCredentials().set('X-Request-ID', uuidv4())
        .send(data)
        .ok(resp=>resp.status<501)
        .then((resp) => {
          console.log('Response',resp);
          if(resp.status===200){
          dispatch(addStaffSuccess());
          dispatch(getStaffListMember());
          }else{
            dispatch(addStaffFail(resp.body));
          }
        })
        .catch((ex) => {
          dispatch(addStaffFail(ex));
        });
    };
  }

  export function deleteStaffStart() {
    return {
      type: types.DELETE_STAFF_START,
    };
  }
  
  export function deleteStaffSuccess() {
    return {
      type: types.DELETE_STAFF_SUCCESS,
    };
  }
  
  export function deleteStaffFail(ex) {
    return {
      type: types.DELETE_STAFF_FAIL,
      error: ex.message,
    };
  }
  
  export function deleteStaffMember(payload) {
    return (dispatch, getState) => {
      const { business } = getState();
        dispatch(deleteStaffStart());
        (business.id
          ? Promise.resolve(business.id)
          : request.get(`${window.Config.API_URL}/business/studioId`).withCredentials().set('X-Request-ID', uuidv4())
            .then((resp) => {
              return resp.body.data.id;
            })
        ).then((businessId) => {
        return request.delete(`${window.Config.API_URL}/client`).withCredentials().set('X-Request-ID', uuidv4())
        .send( {
          business_id:businessId, 
          client_id:payload.client_id,
         })
        .ok(resp=>resp.status<501)
        }).then((resp) => {
            console.log(resp);
            if(resp.status===200){
              dispatch(deleteStaffSuccess());
              dispatch(getStaffListMember());
            }else{
              dispatch(deleteStaffFail(resp.body));
            }
        })
        .catch((ex) => {
          dispatch(deleteStaffFail(ex));
        });
    };
  }


  export function getStaffListStart() {
    return {
      type: types.GET_STAFF_LIST_START,
    };
  }
  
  export function getStaffListSuccess(list) {
    return {
      type: types.GET_STAFF_LIST_SUCCESS,
      list:list
    };
  }
  
  export function getStaffListFail(ex) {
    return {
      type: types.GET_STAFF_LIST_FAIL,
      error: ex.message,
    };
  }
  
  export function getStaffListMember() {
    return (dispatch, getState) => {
      const { business} = getState();
        dispatch(getStaffListStart());
    (business.id
      ? Promise.resolve(business.id)
      : request.get(`${window.Config.API_URL}/business/studioId`).withCredentials().set('X-Request-ID', uuidv4())
        .then((resp) => {
          return resp.body.data.id;
        })
    ).then((businessId) => {
        return request.get(`${window.Config.API_URL}/business/clients`).withCredentials().set('X-Request-ID', uuidv4())
    }).then((resp) => {
            console.log(resp);
          dispatch(getStaffListSuccess(resp.body));
        })
        .catch((ex) => {
          dispatch(getStaffListFail(ex));
        });
    };
  }


  export function updateStaffPasswordStart() {
    return {
      type: types.UPDATE_STAFF_PASSWORD_START,
    };
  }
  
  export function updateStaffPasswordSuccess() {
    return {
      type: types.UPDATE_STAFF_PASSWORD_SUCCESS,
    };
  }
  
  export function updateStaffPasswordFail(ex) {
    return {
      type: types.UPDATE_STAFF_PASSWORD_FAIL,
      error: ex.message,
    };
  }
  
  export function updateStaffPassword(payload) {
    return (dispatch, getState) => {
      const { business, auth } = getState();
        const data = {
            id:auth.userid,
            password:payload.password,
            old_password:payload.old_password
        }
        dispatch(updateStaffPasswordStart());
        return request.put(`${window.Config.API_URL}/client/password`).withCredentials().set('X-Request-ID', uuidv4())
        .send(data)
        .ok(resp=>resp.status<501)
        .then((resp) => {
            console.log(resp);
            if(resp.status===200){
                dispatch(updateStaffPasswordSuccess());
            }else{
              dispatch(updateStaffPasswordFail(resp.body));
            }
        })
        .catch((ex) => {
          dispatch(updateStaffPasswordFail(ex));
        });
    };
  }

  export function updateStaffInfoStart() {
    return {
      type: types.UPDATE_STAFF_INFO_START,
    };
  }
  
  export function updateStaffInfoSuccess() {
    return {
      type: types.UPDATE_STAFF_INFO_SUCCESS,
    };
  }
  
  export function updateStaffInfoFail(ex) {
    return {
      type: types.UPDATE_STAFF_INFO_FAIL,
      error: ex.message,
    };
  }
  
  export function updateStaffInfo(payload) {
    return (dispatch, getState) => {
      const { business, auth } = getState();
        const data = {
            id:auth.userid,
            first_name:payload.firstName, 
            last_name:payload.lastName, 
            email:payload.email, 
            phone:payload.phone,
        }
        dispatch(updateStaffInfoStart());
        return request.put(`${window.Config.API_URL}/client`).withCredentials().set('X-Request-ID', uuidv4())
        .send(data)
        .ok(resp=>resp.status<501)
        .then((resp) => {
          if(resp.status===200){
          dispatch(updateStaffInfoSuccess());
        }else{
          dispatch(updateStaffInfoFail(resp.body));
        }
        })
        .catch((ex) => {
          dispatch(updateStaffInfoFail(ex));
        });
    };
  }